module.exports = __webpack_public_path__ + "static/rd-logo.9caabb72.svg";